/* @flow */

import moment from 'moment';
import { type Pedido } from '../pedidos/types';
import getPrimeiroNomeClientePedido from '../pedidos/get-primeiro-nome-cliente-pedido';
import { COR_ETAPA } from './constants';
import formatarTelefone from '../usuario/formatar-telefone';
import getTitleHora from './get-title-hora';
import getMinutosExibidosNaLista from './get-minutos-exibidos-na-lista';
import { type ViewListaPedido } from '../ducks/atendimento-types';

const formatarTelefonePedido = (pedido: Pedido): ?string => (
    pedido.usuario && pedido.usuario.contatos.length > 0
        ? formatarTelefone(pedido.usuario.contatos[0])
        : null
);

const criarViewListaPedido = (pedido: Pedido): ViewListaPedido => {
    const minutos = getMinutosExibidosNaLista(pedido);

    return {
        id: pedido.id,
        minutos,
        entrada: moment(pedido.entrada),
        titleMinutos: getTitleHora(pedido.etapasId, minutos),
        telefone: formatarTelefonePedido(pedido),
        etapa: pedido.etapa.nome,
        corEtapa: COR_ETAPA[pedido.etapa.etapasId],
        nomeCliente: getPrimeiroNomeClientePedido(pedido),
        origem: pedido.origem,
    };
};

export default criarViewListaPedido;
